import { render, staticRenderFns } from "./AddEmergeCard.vue?vue&type=template&id=07ffec76&scoped=true"
import script from "./AddEmergeCard.vue?vue&type=script&lang=js"
export * from "./AddEmergeCard.vue?vue&type=script&lang=js"
import style0 from "./AddEmergeCard.vue?vue&type=style&index=0&id=07ffec76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ffec76",
  null
  
)

export default component.exports